module.exports = __webpack_public_path__ + "img/离线巡检.a5d22e30.png";